import React from 'react';

import { Container, Modal } from 'react-bootstrap';

import PropTypes from 'prop-types';



class ReciprocityAgreement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userType: this.props.userType || 'homeowner',
    };
  }

  render = () => {
    return <Modal show={this.props.show} onHide={this.props.onHide} size='lg'>
      <Modal.Header closeButton className='py-2'>
        <b>Reciprocity Agreement</b>
      </Modal.Header>
      <Container className="my-5">
        <p className="mb-5">
          With Reciprocity, I am joining a community that is working to make Indigenous land, language and rights more visible, and recognition more real. Over time, collective and widespread participation in Reciprocity will support, rather than erode, Indigenous land rights and governance.
        </p>
        <em>
          {this.state.userType === 'homeowner' ?
            <p>
              By making a Reciprocity Payment for my home, I recognize that I own and benefit from property on Indigenous land. I agree that my Reciprocity Payment:
            </p>
            :
            <p className="mb-5">
              By making a Reciprocity Payment for home, I recognize that I benefit from living and working on Indigenous land. I agree that my Reciprocity Payment:
            </p>
          }

          <ul className="my-3">
            <li>recognizes, and does not in any way compromise, constrain or limit, Indigenous rights and title where I live;</li>
            <li>does not give me any special rights under Canadian or Indigenous law;</li>
            <li>applies to the years paid for only: additional payments can be made at any time for past years;</li>
            <li>supports participating Indigenous Nations to allocate Reciprocity funds towards their own identified community priorities;</li>
            <li>does not reduce or limit the responsibility of local, provincial or federal governments on Indigenous lands, or in relation to my property;</li>
            <li>may be refused by participating Indigenous Nations if my property is in an area where special concerns have been identified;</li>
            <li>recognizes that Reciprocity or Indigenous Nations responsible for the area where I live may contact me about relevant events and initiatives in my community (don’t worry, this won’t be often);</li>
          </ul>
        </em>
      </Container>
    </Modal>;
  };
}

ReciprocityAgreement.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  rural: PropTypes.bool,
};

export default ReciprocityAgreement;
